import { getContactStatus } from '../../graphql/queries';
import {
  GET_CONTACT_STATUS_REQUESTED,
  GET_CONTACT_STATUS_COMPLETED,
  GET_CONTACT_STATUS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const getContactStatusAction = (ContactID) => async (dispatch) => {
  dispatch({
    type: GET_CONTACT_STATUS_REQUESTED,
  });

  debug('ContactID', ContactID);

  try {
    const { data } = await api.graphql({
      query: getContactStatus,
      variables: {
        ContactID,
      },
    });

    dispatch({
      type: GET_CONTACT_STATUS_COMPLETED,
      payload: data.getContactStatus,
    });
  } catch (err) {
    debug(GET_CONTACT_STATUS_FAILED, err);

    dispatch({
      type: GET_CONTACT_STATUS_FAILED,
      payload: err,
    });
  }
};

export default getContactStatusAction;
